/**
 * AP Invoices Demo — demo-mode flag (thin wrapper over the shared framework).
 *
 * THROWAWAY DEMO CODE. The generic multi-demo flag lives in
 * `@/demo/core/demo-mode`; this binds the AP key on top.
 *
 * Start it from the hidden Cmd+K command (type "demo"); see `@/demo/command`.
 */

import { isDemoActive } from '@/demo/core/demo-mode';

export const AP_DEMO_KEY = 'ap';

/** True when the AP invoices demo is active for this tab. */
export function isApDemoMode(): boolean {
  return isDemoActive(AP_DEMO_KEY);
}
